import React, { useEffect, useState } from 'react'
import $ from 'jquery'

export default function Change_Logo() {
     const [selectedComId, setSelectedComId] = useState('');
            const [selectedComName, setSelectedComName] = useState('');
            const [selectedComLogo, setSelectedComLogo] = useState('');
    useEffect(()=>{
         var comname = localStorage.getItem('mem_company_name');
        setSelectedComName(comname);
        var comid = localStorage.getItem('mem_company_id');
        setSelectedComId(comid);
        var comlogo = localStorage.getItem('companylogo');
        setSelectedComLogo(comlogo);
    },[]);

    function updateComImg() {
        
        const fileInput = document.getElementById('memimg_file');
        if (!fileInput.files.length) {
            showAlert("Please select an image first");
            return;
        }

        const formData = new FormData();
        formData.append('comlogo', fileInput.files[0]);
        formData.append('comid', selectedComId);
        // 👆 make sure memberId exists (from session / JS variable)

        fetch('updateCompanyLogoImage.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    document.getElementById('memimg').src = data.image_url;
                    localStorage.setItem('companylogo',data.image_url);
                    showAlert("Company logo updated successfully");
                } else {
                    showAlert(data.message);
                }
            })
            .catch(err => {
                console.error(err);
                showAlert("Image upload failed");
            });
    }

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }
    return (
        <div>
            
                <div className='editbtn_holder'>
                    <div className='membersinfoimg'>
                        <div className='memberimgholder'>
                            <img id="memimg" src={selectedComLogo} />
                        </div>
                        <h2 id="companyname">{selectedComName}</h2>
                        <div className='imgedit'>
                            <button className='mr-10'>Select Image</button>
                            <input type="file" id="memimg_file" accept="image/*" />
                            <button class="ml-10" id="updateProfileImgBtn" onClick={updateComImg}>Update Company Logo</button>
                        </div>


                    
                </div>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
